export default __webpack_public_path__ + "static/media/gb_sample_2.0de71140.jpg";